import moment from "moment";
import dayjs from "dayjs";

export const EventUpdataDetails = (EventDetails, setFormData) => {
  setFormData((prevForm) => ({
    ...prevForm,
    ArtRunner: EventDetails?.eventDetail.eventTypeName || "",
    eventTypeId: EventDetails?.eventDetail.eventTypeId || "",
    ArtType: EventDetails?.eventMode.categoryName,
    categoryId: EventDetails?.eventMode.categoryId,
    ShowName: EventDetails?.eventDetail.eventName,
    isMidNight: EventDetails?.eventDetail.isMidNight ?? false,
    ShowDetails: EventDetails?.eventDetail.eventDescription,
    ShowDate:
      EventDetails?.eventDetail.eventStartDate === null
        ? ""
        : moment(EventDetails?.eventDetail.eventStartDate, "DD-MM-YYYY").format(
          "MM-DD-YYYY",
        ),
    DoorOpens:
      EventDetails?.eventDetail?.eventDoorOpenTime == null ||
        EventDetails?.eventDetail?.eventDoorOpenTime === "Invalid date"
        ? null
        : dayjs(
          moment(EventDetails?.eventDetail?.eventDoorOpenTime, "hh:mm:ss"),
        ),
    StartTime:
      EventDetails?.eventDetail?.eventStartTime == null ||
        EventDetails?.eventDetail?.eventStartTime === "Invalid date"
        ? null
        : dayjs(moment(EventDetails?.eventDetail.eventStartTime, "hh:mm:ss")),
    EndTime:
      EventDetails?.eventDetail?.eventEndTime == null ||
        EventDetails?.eventDetail?.eventEndTime === "Invalid date"
        ? null
        : dayjs(moment(EventDetails?.eventDetail.eventEndTime, "hh:mm:ss")),
    VenueName: EventDetails?.venueDetail.venueName,
    VenueAddress: EventDetails?.venueDetail.venueAddress,
    AddArtists:
      EventDetails?.preAddedArtist?.artistsDetails?.map(
        (item) => item.artistId,
      ) ?? [],
    NumberSpots: EventDetails?.eventMode.noOfSpots,
    TotalSpots: null,
    Guests: EventDetails?.personalApproval.allowGuests,
    SupportVenue: EventDetails?.personalApproval.supportVenue,
    MultipleSignup: EventDetails?.personalApproval.allowMultipleSignup,
    Requirements: EventDetails?.eventDetail.requirements,
    AutoRepeat: EventDetails?.scheduleEvent.doRepeat,
    RepeatType:
      EventDetails?.scheduleEvent.repeatType == "IDontKnow"
        ? null
        : EventDetails?.scheduleEvent.repeatType,
    RepeatEndDate:
      EventDetails?.scheduleEvent.endDate === null ||
        EventDetails?.scheduleEvent.startDate === "Invalid date"
        ? null
        : moment(EventDetails?.scheduleEvent.endDate, "DD-MM-YYYY").format(
          "MM-DD-YYYY",
        ),
    RepeatStartDate:
      EventDetails?.scheduleEvent?.nextEvent == null ||
        EventDetails?.scheduleEvent?.nextEvent === "Invalid date"
        ? null
        : moment(EventDetails?.scheduleEvent.nextEvent, "DD-MM-YYYY").format(
          "DD/MM/YYYY",
        ),
    WeekMonth: EventDetails?.scheduleEvent?.monthWeek,
    DayWeek: EventDetails?.scheduleEvent?.weekDay,
    VisibilityType: EventDetails?.eventDetail.eventVisibility,
    AlwaysVisible: EventDetails?.artistSignupVisibility.signupVisibility ?? 1,
    CustomDate:
      EventDetails?.artistSignupVisibility.visibilityStartDate === null ||
        EventDetails?.artistSignupVisibility.visibilityStartDate ===
        "Invalid date"
        ? null
        : moment(
          EventDetails?.artistSignupVisibility.visibilityStartDate,
          "DD-MM-YYYY",
        ).format("MM-DD-YYYY"),
    CustomTime:
      EventDetails?.artistSignupVisibility.visibilityStartTime === null ||
        EventDetails?.artistSignupVisibility.visibilityStartTime ===
        "Invalid date"
        ? null
        : dayjs(
          moment(
            EventDetails?.artistSignupVisibility.visibilityStartTime,
            "hh:mm:ss",
          ),
        ),
    Settings: EventDetails?.artistSignupVisibility.saveSettings,

    // ===== CRITICAL FIXES FOR EVENT ENTRY =====
    EventEntry: EventDetails?.eventPricing.eventEntry,

    // VIP Pricing - Store both USD and display values
    VIPPrice: EventDetails?.eventPricing.VIPPrice || null, // USD value
    displayVipPrice: EventDetails?.eventPricing.displayVipPrice || null, // Will be converted in component

    // Economy Pricing - Store both USD and display values
    economyPrice: EventDetails?.eventPricing.economyPrice || null, // USD value
    displayEconomyPrice: EventDetails?.eventPricing.displayEconomyPrice || null, // Will be converted in component

    // Seats
    VIPSeats: EventDetails?.eventPricing.VIPSeats || null,
    economySeats: EventDetails?.eventPricing.economySeats || null,
    freeSeats: EventDetails?.eventPricing.freeSeats || null,

    // Currency Information
    currency: EventDetails?.eventPricing.currency ||null,
    baseCurrency: EventDetails?.eventPricing.baseCurrency ||  "USD",
    exchangeRate: EventDetails?.eventPricing.exchangeRate || 1,
    currencySymbol: EventDetails?.eventPricing.currencySymbol || null,

    // Payment Provider
    paymentProvider: EventDetails?.eventPricing.paymentProvider || null,
    ticketPageLink: EventDetails?.eventPricing.ticketPageLink || null,

    // Images
    TicketImages: EventDetails?.eventDetail.eventImages || null,
    Expect: EventDetails?.exceptFirst || "",
    Expect1: EventDetails?.exceptSecond || "",
    Expect2: EventDetails?.exceptThird || "",
    EventPoster: EventDetails?.eventDetail.eventPosterImages || [],
    latitude: EventDetails?.latitude || null,
    longitude: EventDetails?.longitude || null,
  }));
};